import LoadingIndicator from 'components/LoadingIndicator';
import './CardsTableLoadingIndicator.css';

export const CardsTableLoadingIndicator = () => {
  return (
    <div className="cards-table-loading-indicator">
      <LoadingIndicator message="Loading cards..." />
    </div>
  );
};
